import cookies from 'js-cookie';
import _ from 'underscore';

const thirtyDays = 30;

export function getOptimizelyRedirect() {
  if (!window.optimizely) return false;
  if (window.location.search.indexOf('optimizely_disable=true') > -1)
    return false;
  let state;
  let redirectInfo;

  try {
    state = window.optimizely.get('state');
    redirectInfo = state.getRedirectInfo();
    return redirectInfo;
  } catch (e) {
    return false;
  }
}

export function isShopkeepUrl(url) {
  return (
    url.indexOf('shopkeep') > -1 ||
    url.indexOf('uatshopkeep') > -1 ||
    url.indexOf('localhost') > -1
  );
}

export function getArrayFromCookie(name) {
  const value = cookies.get(name);
  if (value) return JSON.parse(value);
  return [];
}

export function formatDate(d) {
  const pad = (val) => `0${val}`.slice(-2);
  const date = [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join(
    '-'
  );
  const time = [pad(d.getHours()), pad(d.getMinutes())].join(':');

  return `${date} ${time}`;
}

export function getReferrer() {
  const urlExp = /^(https|http)?(:\/\/)?(www\.)?([^./?]+).*$/g;

  if (document.referrer === window.location.href.split('#')[0]) return '';
  if (getOptimizelyRedirect()) return '';

  return document.referrer ? urlExp.exec(document.referrer)[4] : '';
}

export function lastUtm() {
  const utmSources = getArrayFromCookie('utm_source_tracker');
  const utmMediums = getArrayFromCookie('utm_medium_tracker');
  const utmCampaigns = getArrayFromCookie('utm_campaign_tracker');
  const lastSource = utmSources[utmSources.length - 1];
  const lastMedium = utmMediums[utmSources.length - 1];
  const lastCampaign = utmCampaigns[utmSources.length - 1];
  return [lastSource, lastMedium, lastCampaign];
}

export function formatUtmParam(param, value) {
  let newValue = '';

  if (param === 'utm_medium') {
    newValue = value === 'not_set' ? 'organic' : value;
  }
  if (param === 'utm_source') {
    newValue = value === 'not_set' ? getReferrer() || 'not_set' : value;
  }
  if (param === 'utm_date') {
    newValue = formatDate(new Date());
  }

  return newValue || value;
}

export function setAttributionTracking(qsParams) {
  const MAX_TRACKER_LENGTH = 10;
  const paramNames = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_date'];
  const trackers = paramNames.map((param) =>
    getArrayFromCookie(`${param}_tracker`)
  );
  const values = {};

  paramNames.forEach((param) => {
    const value = qsParams[param]
      ? decodeURIComponent(qsParams[param])
      : 'not_set';
    values[param] = formatUtmParam(param, value);
  });

  if (window.location.pathname.indexOf('/thank-you') > -1) return;
  if (window.location.pathname.indexOf('/support/') > -1) return;
  if (isShopkeepUrl(getReferrer())) return;
  if (trackers[0].length > MAX_TRACKER_LENGTH) return;
  // Don't track if current UTM matches last recorded
  if (
    _.isEqual(
      [values.utm_source, values.utm_medium, values.utm_campaign],
      lastUtm()
    ) &&
    cookies.get('utm_tracked')
  ) {
    return;
  }

  paramNames.forEach((param, index) => {
    trackers[index].push(values[param]);
    cookies.set(`${param}_tracker`, JSON.stringify(trackers[index]), {
      expires: thirtyDays
    });
  });

  cookies.set('utm_tracked', 'true');
}

export default { setAttributionTracking };
